const $$splitComponentImporter = () => import('/home/ubuntu/actix-web-dome/ui/src/apps/main/routes/_main/user/app/$appId/features-barcode/list-parse.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { BarcodeParseRecordFilterParamSchema } from '@apps/main/features/user/pages/app/detail/feature-barcode/list-parse-schema';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/_main/user/app/$appId/features-barcode/list-parse')({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  validateSearch: BarcodeParseRecordFilterParamSchema
});